import { Button } from "@omni/ui/components/Button/button.component";
import { cn } from "@omni/utils/styles";

import { useSearchBarContext } from "@/components/Search/SearchBar/context/searchBar.context";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

type Props = {
    className?: string;
};

export const CloseButton = ({ className }: Props) => {
    const { onClose } = useSearchBarContext();
    const { t } = useGranite();

    return (
        <Button
            type={"button"}
            color={"light-gray"}
            className={cn(
                "tw:absolute tw:w-10 tw:h-10 tw:top-4 tw:-right-14 tw:bg-white tw:hidden",
                "tw:lg:block",
                className
            )}
            onClick={onClose}
            tabIndex={0}
            aria-label={t("accessibility.searchBox.close")}
        >
            <i className={cn("las la-times")} />
        </Button>
    );
};
